import {LiveReducer, ReducerFromState} from "../../../@types/reducers";

export const isInitialized = (state: ReducerFromState<LiveReducer>): boolean => state.live.initializing;